import IngredientDelete from './IngredientDelete'
export {IngredientDelete}
export default IngredientDelete
